import getDateFnsLocale from "./get-date-fns-locale.js";
import { localizationUtils } from "@flights/web-api-utils-universal";
export function createDateLocaleLoader(locale) {
    const dateFnsLocale = localizationUtils.OurLocalesToDateFNSLocaleMapping[locale];
    return async () => getDateFnsLocale(dateFnsLocale ?? locale);
}
